import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { Product } from '../types/state'

const initialState: Product = {}

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct: (state, action: PayloadAction<Product>) => {
      const { previewImg, id } = action.payload
      state.previewImg = previewImg
      state.id = id
    },
  },
})

export const { setProduct } = productSlice.actions

export default productSlice.reducer
